<template>
  <form method="post" @submit.prevent="send">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title is-centered">
          {{ formTitle }}
        </p>
      </header>
      <section class="modal-card-body">
        <form-wrapper :validator="$v.form">
          <form-group
            horizontal
            name="id"
            attribute="attributes.id"
            :label="$t('attributes.id')"
          >
            <b-input
              v-model="form.id"
              name="id"
              :placeholder="$t('message.please_input') + $t('attributes.id')"
              :disabled="true"
              expanded
            >
            </b-input>
          </form-group>
          <form-group
            horizontal
            name="country_code"
            attribute="attributes.country"
            :label="$t('attributes.country')"
          >
            <b-select
              v-model="form.country_code"
              name="country_code"
              :disabled="!isCreate"
            >
              <option value="" disabled>{{
                $t('message.please_select') + $t('attributes.country')
              }}</option>
              <option v-for="c in countries" :key="c.code" :value="c.code">
                {{ c.code + c.name }}
              </option>
            </b-select>
          </form-group>
          <form-group
            horizontal
            name="name"
            attribute="attributes.city_name"
            :label="$t('attributes.city_name')"
          >
            <b-input
              v-model="form.name"
              name="name"
              :placeholder="
                $t('message.please_input') + $t('attributes.city_name')
              "
              expanded
            >
            </b-input>
          </form-group>
          <form-group
            horizontal
            name="english_name"
            attribute="attributes.english_name"
            :label="$t('attributes.english_name')"
          >
            <b-input
              v-model="form.english_name"
              name="english_name"
              :placeholder="
                $t('message.please_input') + $t('attributes.english_name')
              "
              expanded
            >
            </b-input>
          </form-group>
          <form-group
            horizontal
            name="time_zone"
            attribute="attributes.city_gmt"
            :label="$t('attributes.city_gmt')"
          >
            <b-input
              v-model="form.time_zone"
              name="time_zone"
              :placeholder="
                $t('message.please_input') + $t('attributes.city_gmt')
              "
              expanded
            >
            </b-input>
          </form-group>
        </form-wrapper>
      </section>
      <footer class="modal-card-foot">
        <b-button class="is-fullwidth" @click="$parent.close()">
          {{ $t('attributes.close') }}
        </b-button>
        <b-button
          type="is-primary"
          :loading="sending"
          class="is-fullwidth"
          native-type="submit"
        >
          {{ submitTitle }}
        </b-button>
      </footer>
    </div>
  </form>
</template>

<script>
import { maxLength, required } from 'vuelidate/lib/validators'

export default {
  name: 'WeatherForm',
  props: {
    detail: {
      required: false,
      type: Object
    },
    countries: {
      required: false,
      type: Array
    },
    sending: Boolean,
    isCreate: Boolean
  },
  data() {
    return {
      formTitle:
        this.$t(this.isCreate ? 'attributes.add' : 'attributes.modify') +
        this.$t('attributes.city_weather'),
      submitTitle: this.$t(
        this.isCreate ? 'attributes.add' : 'attributes.update'
      ),
      form: this.extractFormValues(this.detail),
      loading: false
    }
  },
  validations: {
    form: {
      id: { required },
      name: { required, maxLength: maxLength(20) },
      english_name: { required, maxLength: maxLength(40) },
      time_zone: { maxLength: maxLength(10) },
      country_code: { required }
    }
  },
  methods: {
    extractFormValues(data) {
      return {
        id: data.id,
        name: data.name,
        english_name: data.english_name,
        time_zone: data.time_zone,
        country_code: data.country_code.trim()
      }
    },
    async send() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }
      this.$emit('onSend', this.form)
    }
  }
}
</script>
